import React, { useState } from "react";

const SupportTable = () => {
  return (
    <></>
  );
};

export default SupportTable;
